import React from 'react';
import PropTypes from 'prop-types';
import { Table, TableBody } from '@material-ui/core';
import moment from 'moment';
import mapUtilities from '../../../../utils/map';
import { Loader } from 'kangarootime-ui';
import Header from './Header';
import Row from './Row';
import TotalNumberOfBreaksRow from './TotalNumberOfBreaksRow';

const EmployeeBreaks = ({ employees, isLoading, visibleDates, employeeSchedules, shiftsThisWeek }) => {
  const getNumberOfBreaksRequired = () => {
    let minutesMap = new Map();
    const formattedDates = visibleDates.map(d => moment(d).format('YYYY-MM-DD'));
    formattedDates.forEach(date => minutesMap.set(date, 0));

    shiftsThisWeek.forEach(shift => {
      const { start, breakMinutes } = shift;
      const formattedDate = moment(start).format('YYYY-MM-DD');
      let currentNumberOfBreaks = minutesMap.get(formattedDate);

      if (parseInt(breakMinutes, 10) > 0) {
        currentNumberOfBreaks += 1;
        minutesMap.set(formattedDate, currentNumberOfBreaks);
      }
    });

    return mapUtilities.toObject(minutesMap);
  };

  // turn our map into an object
  const numberOfBreaksInWeekObject = getNumberOfBreaksRequired();
  // turn contents of object into an array where each key-value pair is it's own object
  const arrayOfBreakObjects = Object.keys(numberOfBreaksInWeekObject).map(key => ({
    date: key,
    amount: numberOfBreaksInWeekObject[key].toString()
  }));

  // only show employees in the breaks table that have a shift schedule this week
  const employeesIdsWithShift = shiftsThisWeek.map(shift => shift.employeeId);
  const employeesToShow = employees.filter(employee => employeesIdsWithShift.includes(employee.id));

  return (
    <Loader loading={isLoading}>
      <Table className='schedulingTable'>
        <Header weekDates={visibleDates} employeeCount={employeesToShow.length} />
        <TableBody>
          <TotalNumberOfBreaksRow numberOfBreaksPerDay={arrayOfBreakObjects} />
          { employeesToShow.map(employee => (
            <Row
              employee={employee}
              schedules={employeeSchedules[employee.id]}
              key={employee.id}
              datesInWeek={visibleDates}
            />
          ))}
        </TableBody>
      </Table>
    </Loader>
  );
};

EmployeeBreaks.propTypes = {
  employees: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    image: PropTypes.string,
    name: PropTypes.string
  })),
  isLoading: PropTypes.bool,
  visibleDates: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  employeeSchedules: PropTypes.shape({
    [PropTypes.number]: PropTypes.shape({ // number is an employee id
      [PropTypes.string]: PropTypes.arrayOf(PropTypes.shape({ // string is a date in 'YYYY-MM-DD' format
        id: PropTypes.number,
        breakMinutes: PropTypes.number,
        employeeId: PropTypes.number,
        roomId: PropTypes.number,
        roomName: PropTypes.string,
        start: PropTypes.string,
        end: PropTypes.string
      }))
    })
  }),
  shiftsThisWeek: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    breakMinutes: PropTypes.number,
    employeeId: PropTypes.number,
    roomId: PropTypes.number,
    roomName: PropTypes.string,
    start: PropTypes.string,
    end: PropTypes.string
  }))
};

export default EmployeeBreaks;
